var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveDriverIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.945,
    height: 20,
    viewBox: "0 0 19.945 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "exit_to_app_FILL0_wght400_GRAD0_opsz48",
    d: "M7.662,25.9A1.7,1.7,0,0,1,6,24.238V18.421H7.662v5.817h16.62V7.562H7.662v5.873H6V7.562A1.7,1.7,0,0,1,7.662,5.9h16.62a1.7,1.7,0,0,1,1.662,1.662V24.238A1.7,1.7,0,0,1,24.283,25.9Zm6.454-4.626L12.87,20.027l3.269-3.269H6V15.1H16.139L12.87,11.828l1.247-1.247,5.346,5.346Z",
    transform: "translate(-6 -5.9)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveDriverIcon);
export default __webpack_public_path__ + "static/media/moveDriverIcon.5965368da0acad731c18750a83ebf123.svg";
export { ForwardRef as ReactComponent };